import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SignIn from "./pages/SignIn";
import Home from "./pages/Home";
import SignUp from "./pages/SignUp";
import EmailVerification from "./pages/EmailVerification";
import VerifyEmail from "./pages/VerifyEmail";
import AdminDashboard from "./pages/AdminDashboard";
import Settings from "./pages/Settings";

import { ThemeProvider } from '@mui/material/styles';
import { theme } from './theme/theme';
import { GoogleOAuthProvider } from '@react-oauth/google';

export default function App() {
  return (  
    <GoogleOAuthProvider clientId={process.env.REACT_APP_PHOTOS_CLIENT_ID}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/admin_dashboard" element={<AdminDashboard />} />
            <Route path="/" element={<Home />} />
            <Route path="/email_verification/:token" element={<EmailVerification />} />
            <Route path="/verify_email" element={<VerifyEmail />}/>
            <Route path="/settings" element={<Settings />}/>
            <Route caseSensitive path="*" element={<Navigate replace to="/404" />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
}